import React, { useEffect, useState, useContext } from 'react';

import Header from '../header';
import Loading from 'components/loading';
import Footer from '../footer/footer';
import { ProfileContext } from 'providers/profile.provider';
import PartnerAppHeader from '../header/partner-header';

type WrapperProps = {
    loading?: boolean;
};

const Wrapper: React.FC<WrapperProps> = ({
    loading = false,
    children,
}): JSX.Element => {
    const [show, setShow] = useState<boolean>(false);
    const { profile } = useContext(ProfileContext);

    useEffect(() => setShow(true), []);

    return (
        <>
            <div className={['wrap', show ? 'show' : null].join(' ')}>
                {profile === 'default' && <Header />}
                {profile === 'partners' && <PartnerAppHeader />}
                {!loading ? children : <Loading />}
            </div>
            <Footer />
        </>
    );
};

export default Wrapper;
